var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:p-2 grid grid-cols-1 gap-2"},[(_vm.fulfilmentGroup)?_c('picking-group-list-item',{staticClass:"mb-5",attrs:{"group":_vm.fulfilmentGroup}}):_vm._e(),_vm._l((_vm.getFulfilmentGroupItems),function(item){return _c('picking-list-item',{key:item.productId,attrs:{"item":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }